<i18n>
{
  "fr": {
    "hide-menu-label": "Masquer le menu",
    "show-menu-label": "Afficher le menu",
    "close": "Fermer",
    "zoomIn": "Zoomer",
    "zoomOut": "Dézommer",
    "centerToExtent": "Rencentrer sur la zone d'intérêt"
  },
  "de": {

  }
}
</i18n>

<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  mounted () {
    // init locale for datepicker
    this.$material.locale = {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'dd.MM.yyyy',
      days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      shortDays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      shorterDays: ['D', 'L', 'Ma', 'Me', 'J', 'V', 'S'],
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      shortMonths: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Jui', 'Août', 'Sept', 'Oct', 'Nov', 'Dec'],
      shorterMonths: ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D'],
      firstDayOfAWeek: 0
    }
  }
}
</script>

<style lang="scss">

@import '@/styles/variable.scss';

// General layout

@font-face {
  font-family: 'OpenSans';
  src: local('OpenSans'), url(./fonts/OpenSans/OpenSans-Regular.ttf) format("truetype");
}

#main-container {
  font-family: 'OpenSans', sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app {
  display: flex;
  overflow:hidden;
}

// Views

.content {
  display: flex;
  flex-direction: column;

  width: 100%;

  height: 100vh;

  @media (max-height: 500px) {
    height: 100vh;
  }

  .content-view {
    height: 100%;
  }
}

.sidebar {
  display: flex;
  width: 0px;
  height: 100vh;
  position: fixed;
  z-index: 1;
  background-color: #ffffffed;

  @media (max-height: 500px) {
    height: 100vh;
  }

  &.right {
    right: 0px;
    transition: all 200ms ease-out;
  }

  &.open {
    display: flex;
    width: 20vw;
    min-width: 365px;

    .side-view {
      display: block;
    }

    .side-panel-control.right {
      left: 20vw;
    }
    .side-panel-control.left {
      right: 20vw;
    }

  }

  &.wide {
    width: 50vw;
  }

  .side-view {
    height: 100%;
    display: none;
  }
}

.bottom-view {
  display: none;
  background-color: #ffffff9c;
  backdrop-filter: blur(10px);
  &.open {
    display: block;
    height: 275px;
    bottom: 0px;
    position: fixed;
    width: 100vw;

    &.left-panel-open {
      @media(min-width: 900px) {
        width: calc(100vw - 365px);
        left: 365px;
      }
    }
  }
}

// General rules

::selection {
  color: white !important;
  background: #8e8e8ea6 !important;
}

.clickable {
  cursor: pointer;
}

.md-list-item-text {
  font-size: 14px;
}

.md-menu.md-select input {
  font-size: 14px !important;
}

.md-caption, .md-title {
  user-select: none;
}

.geom-type-icon {
  display: inline-block;
}

h3 {
  color: $titleColor;
}

.md-tooltip {
  transform: scale(1.2);
  background-color: #444444 !important;
  border-radius: 0px !important;
  color: white !important;
}

.vue-slider-dot-tooltip-inner {
  background-color: #444444 !important;
}

label i.label-icon {
  font-size: 15px !important;
  margin-top: -3px;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
}

.admin.fullpage {
  display: flex;
  justify-content: center;
  .main-content {
    h1 {
      margin-bottom: 60px;
    }
    max-width: 1050px;
  }
}

.admin.with-left-bar {
  .main-panel {
    margin: 0 auto;
    padding: 35px !important;
    max-width: 1050px;
    overflow: auto;
  }
}
</style>
